import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { FakeResponseInterceptor } from './fake-response-interceptor';

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: FakeResponseInterceptor,
    multi: true,
  },
];
